<template>
  <div class="upload-wrap">
    <el-upload
      ref="elUpload"
      :class="{ 'hide-upload-holder': hideUpload }"
      :action="getUploadUrl"
      :headers="getUploadHeader"
      :auto-upload="true"
      :multiple="true"
      :limit="limitCount"
      :accept="acceptType.join(',')"
      :file-list="fileList"
      :listType="listType"
      :on-preview="picCardPreview"
      :before-upload="beforePicUpload"
      :on-remove="removePic"
      :on-progress="uploadOnProgress"
      :on-error="uploadError"
      :on-success="uploadPicSuccess"
      :on-exceed="handleExceed"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <div v-if="listType === 'picture-card'" slot="default" class="el-icon-plus" style="color: #409eff">上传图片</div>
      <slot v-if="listType === 'text'" name="btn"></slot>
    </el-upload>

    <el-dialog append-to-body :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  name: 'UploadPicture',
  props: {
    /**
     * 允许上传的图片张数，默认1张
     */
    limitCount: {
      type: Number,
      default: 1
    },
    /**
     * 图片尺寸，默认2MB
     */
    imgSize: {
      type: Number,
      default: 0
    },
    /**
     * 根据已有图片URL，回填图片
     */
    alreadyFile: {
      type: [String, Array],
      default: ''
    },
    acceptType: {
      type: Array,
      default: () => ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
    },
    uploadDir: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    // 上传链接后缀
    urlSuffix: {
      type: String,
      default: '/user/file/upload'
    }
  },
  computed: {
    getUploadHeader() {
      return {
        Authorization: getToken()
      }
    },
    getUploadUrl() {
      return `${process.env.VUE_APP_API_ROOT}${this.urlSuffix}`
    }
  },
  watch: {
    alreadyFile: {
      handler(val) {
        if (this.limitCount == 1) {
          this.hideUpload = true
        }
        if (typeof val == 'string' && val != '') {
          this.fileList = [{ url: val }]
        }
        if (Array.isArray(val) && val.length != 0) {
          this.initImage(val)
        }
        if (val == '' || val === null) {
          this.hideUpload = false
          this.fileList = []
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      fileList: [],
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      progressFlag: false
    }
  },
  created() {
    let val = this.alreadyFile
    if (typeof val == 'string' && val != '' && this.limitCount == 1) {
      this.fileList = [{ url: val }]
      this.hideUpload = true
    }
  },
  methods: {
    initImage(val) {
      let arrSet = new Set(val)
      let tempVal = []
      for (let k of arrSet) {
        tempVal.push(k)
      }

      let tempArr = []
      tempVal.forEach((item) => {
        let tempObj = { url: '' }
        tempObj.url = item
        tempArr.push(tempObj)
      })
      this.fileList = tempArr
    },
    picCardPreview(file) {
      //上传图预览
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforePicUpload(file) {
      const { acceptType, imgSize } = this
      //图片校验
      const limitPic = acceptType.includes(file.type)
      if (!limitPic) {
        this.$message.warning(`请上传格式为${acceptType.join('、')}的图片`)
      }
      const limitSize = imgSize > 0 ? file.size / 1024 / 1024 < imgSize : true
      if (!limitSize) {
        this.$message.warning(`上传图片大小不能超过${imgSize}M`)
      }
      return limitPic && limitSize
    },
    uploadPicSuccess(file) {
      console.log({ file })
      this.fileList.push({ url: file.data })
      this.hideUpload = this.fileList.length >= this.limitCount
      this.$emit('uploadSuccess', this.fileList)
    },
    removePic(file, fileList) {
      console.log('removePic', file, fileList)
      //移除图片
      this.hideUpload = fileList.length >= this.limitCount
      this.fileList = fileList
      // this.$emit("uploadSuccess", this.fileList);
      this.$emit('removeSuccess')
    },
    uploadOnProgress(file, fileList) {
      this.hideUpload = this.fileList.length + 1 >= this.limitCount
    },
    uploadError(err, file, fileList) {
      console.log({ err })
      this.hideUpload = this.fileList.length >= this.limitCount
    },
    handleExceed() {
      // this.hideUpload = this.fileList.length >= this.limitCount;
      //文件超出个数限制
      this.$message.warning('一次只能上传 ' + this.limitCount + ' 张图片')
    },
    clearFiles() {
      this.$refs.elUpload.clearFiles()
      this.$nextTick(() => {
        this.fileList = []
        this.hideUpload = false
      })
    }
  }
}
</script>

<style scoped>
.upload-wrap {
  margin-top: 10px;
}
.upload-wrap >>> .hide-upload-holder .el-upload--picture-card {
  display: none;
}
.upload-wrap ::v-deep .el-upload-list__item {
  transition: none !important;
}
</style>
